import { Box, Button, Flex } from '@chakra-ui/react';
import React from 'react';
import { getColorFromStatus, getHoverStyle } from './seatUtils.js'; // Importa le funzioni di utilità
import Screen from './Screen.tsx';

export default function FaiHall({seatsByRow, isSeatInCart, handleSeatClick}) {
    return(
      <>
      <Screen width={{base:"260px", md:"800px"}} height={{base:"30px", md:"100px"}} text="Palco"/>
        <Flex direction="column" h="auto">
          {
          Object.keys(seatsByRow)
          .sort() // Ordina le chiavi alfabeticamente
          .map(row => (
            <Flex key={row} justify={'center'}>
              {seatsByRow[row].map((seat, index) => {
                // Verifica se il posto è nel carrello
                const isInCart = isSeatInCart(seat.fila, seat.numero, seat.sezione);
                if(isInCart) seat.stato = "Prenotato";
                
                return (
                  <React.Fragment key={seat._id}>
                    <Box m={{base: 0.4, md:2}}>
                      <Button
                        size={{base:"xxs", md:"xl"}}
                        w={{base:"16px", md:"40px"}}
                        fontSize={{base:"7px", md:"14px"}}
                        h={{base:"2vh", md:"4vh"}}
                        bg={getColorFromStatus(seat)}
                        disabled={seat.stato !== "Disponibile"}
                        _hover={getHoverStyle(seat)}
                        cursor={(seat.stato === "Disponibile") ? "pointer" : "not-allowed"}
                        onClick={() => {
                          // FIXME: Questo vale solo quando chiudi le prenotazioni
                          //if(true) return;
                          // FIXME: Rimuovi la riga sopra per far funzionare i posti 
                          handleSeatClick(seat.fila, seat.numero, seat.sezione);
                        }}
                        textColor={seat.stato === "Vuoto" ? "transparent" : "default"}
                      >
                          <Box as="span" letterSpacing="0.05em">
                            {`${seat.fila}${seat.numero}`}
                          </Box>
                      </Button>
                    </Box>
                    {/* TODO: Aggiungi uno spazio vuoto dopo il posto 10 */}
                    {/*index === 9 && <Box marginLeft={{base: "10px", md:"8vh"}}></Box>*/}
                  </React.Fragment>
                );
              })}</Flex>
            ))}
          </Flex>
        </>
    )
}
